export default function TopBanner() {
  return (
    <div className="space-y-3 mb-6">
      <a href="https://ibit.ly/ufanance" target="_blank" rel="noopener noreferrer">
        <img 
          src="https://image.cdend.com/wp-content/uploads/2024/03/728x200-ufanance.gif" 
          alt="Banner" 
          className="w-full h-auto"
        />
      </a>
      <a href="https://ibit.ly/ufac4" target="_blank" rel="noopener noreferrer">
        <img 
          src="https://image.cdend.com/wp-content/uploads/2024/03/728x200-UFAC4.gif" 
          alt="Banner" 
          className="w-full h-auto"
        />
      </a>
      <a href="https://ibit.ly/ufazeed" target="_blank" rel="noopener noreferrer">
        <img 
          src="https://image.cdend.com/wp-content/uploads/2024/03/728x200-ufazeed.gif" 
          alt="Banner" 
          className="w-full h-auto"
        />
      </a>
    </div>
  );
}